import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { BankTransferCompleteTemplate } from 'components/Templates'

const BankTransferComplete: FC = () => {
  return (
    <Layout headline={'銀行振込'} iconPath={'/icon/white/revenue.svg'} title={'銀行振込'}>
      <BankTransferCompleteTemplate />
    </Layout>
  )
}

export default BankTransferComplete
